import SnippetContainer from './snippet_container';

const Snippet = SnippetContainer;
export default Snippet;
